<template>
<div class="writeCardList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">设备卡库列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="EID:">
                <el-input v-model="form.eid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="IMEI:">
                <el-input v-model="form.imei" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="ICCID:">
                <el-input v-model="form.iccid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="接入号:">
                <el-input v-model="form.phone" placeholder="请输入..."></el-input>
            </el-form-item>
            
            <el-form-item label="写号状态:">
                <el-select v-model="form.writeStatus" placeholder="请选择写号状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待写卡" value="0"></el-option>
                    <el-option label="充值成功待写号" value="1"></el-option>
                    <el-option label="写号中" value="2"></el-option>
                    <el-option label="写号完成" value="3"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="开始时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.startTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="结束时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.endTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-delete" class="themed-button" @click="batchDelete">批量删除</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-back" class="themed-button" @click="exportExcel">批量导出</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importData">导入</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" class="themed-button" @click="batchUpdateImeiDialog">批量修改IMEI</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="EID" prop="eid" show-overflow-tooltip></el-table-column>
            <el-table-column label="IMEI" prop="imei" show-overflow-tooltip></el-table-column>
            <el-table-column label="ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="接入号" prop="phone" show-overflow-tooltip></el-table-column>
            <el-table-column label="写号状态" prop="writeStatus" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatWriteStatus(scope.row.writeStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="当前省份" prop="province" show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    {{ formatProvince(scope.row.province) }}
                </template> -->
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.updateTime) }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150px">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.writeStatus === '0' || scope.row.writeStatus === 0" type="primary" size="mini" class="themed-button" @click="handleWrite(scope.row)">写卡</el-button>
                    <el-button type="primary" size="mini" class="themed-button" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 写卡弹框 -->
    <el-dialog title="写卡" :visible.sync="writeDialogVisible" width="500px">
        <el-form :model="writeForm" label-width="100px">
            <el-form-item label="新ICCID:">
                <el-input v-model="writeForm.newIccid" placeholder="请输入新ICCID"></el-input>
            </el-form-item>
            <el-form-item label="新接入号:">
                <el-input v-model="writeForm.newMsisdn" placeholder="请输入新接入号"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitWrite">确 定</el-button>
            <el-button class="themed-button" type="primary"  @click="writeDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 编辑弹框 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="500px">
        <el-form :model="editForm" label-width="100px">
            <el-form-item label="EID:">
                <el-input v-model="editForm.eid" placeholder="请输入EID" disabled></el-input>
            </el-form-item>
            <el-form-item label="IMEI:" required>
                <el-input v-model="editForm.imei" placeholder="请输入IMEI"></el-input>
            </el-form-item>
            <el-form-item label="ICCID:" required>
                <el-input v-model="editForm.iccid" placeholder="请输入ICCID"></el-input>
            </el-form-item>
            <el-form-item label="接入号:" required>
                <el-input v-model="editForm.phone" placeholder="请输入接入号"></el-input>
            </el-form-item>
            <el-form-item label="当前省份:">
                <el-select v-model="editForm.province" placeholder="请选择省份">
                    <el-option
                        v-for="(label, value) in provinceMap"
                        :key="value"
                        :label="label"
                        :value="label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitEdit">确 定</el-button>
            <el-button class="themed-button"  type="primary"  @click="editDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="设备卡信息:">
                <el-input v-model="importCardInfo" type="textarea" rows="6" placeholder="请输入EID ICCID 接入号 IMEI，每行一组，IMEI可为空，用空格分开"></el-input>
                <div style="color:#f00;">请输入EID ICCID 接入号 IMEI，每行一组，IMEI可为空，用空格分开</div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="importDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量删除弹框 -->
    <el-dialog title="批量删除" :visible.sync="deleteDialogVisible" width="500px">
        <el-form label-position="right" label-width="200px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='deleteFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="EID信息:">
                <el-input v-model="deleteEidInfo" type="textarea" rows="6" placeholder="请输入EID，每行一个"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitBatchDelete">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportDeleteTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="deleteDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量修改IMEI弹框 -->
    <el-dialog title="批量修改IMEI" :visible.sync="updateImeiDialogVisible" width="500px">
        <el-form label-position="right" label-width="150px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='updateImeiFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="IMEI信息:">
                <el-input v-model="imeiInfo" type="textarea" rows="6" placeholder="请输入ICCID IMEI，每行一组，用空格分开"></el-input>
                <div style="color:#f00;">请输入ICCID IMEI，每行一组，用空格分开</div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitUpdateImei">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportImeiTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="updateImeiDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listWriteCard, 
    deleteById, 
    exportWriteCardSync, 
    importExcel, 
    batchDelete, 
    writeCard, 
    editCard,
    batchUpdateImei
} from '@/api/writeCardManagement/writeCardList.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'writeCardList',
    mixins: [resize],
    data() {
        return {
            form: {
                eid: '',
                imei: '',
                iccid: '',
                phone: '',
                writeStatus: '',
                startTime: '',
                endTime: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 写卡弹框数据
            writeDialogVisible: false,
            writeForm: {
                eid: '',
                newIccid: '',
                newMsisdn: ''
            },

            // 编辑弹框数据
            editDialogVisible: false,
            editForm: {
                id: '',
                eid: '',
                imei: '',
                iccid: '',
                phone: '',
                province: ''
            },
            
            // 省份映射数据
            provinceMap: {
                '0': '默认',
                '110000': '北京市', 
                '120000': '天津市',
                '130000': '河北省',
                '140000': '山西省',
                '150000': '内蒙古自治区',
                '210000': '辽宁省',
                '220000': '吉林省', 
                '230000': '黑龙江省',
                '310000': '上海市',
                '320000': '江苏省',
                '330000': '浙江省',
                '340000': '安徽省',
                '350000': '福建省',
                '360000': '江西省',
                '370000': '山东省',
                '410000': '河南省',
                '420000': '湖北省',
                '430000': '湖南省',
                '440000': '广东省',
                '450000': '广西壮族自治区',
                '460000': '海南省',
                '500000': '重庆市',
                '510000': '四川省',
                '520000': '贵州省',
                '530000': '云南省',
                '540000': '西藏自治区',
                '610000': '陕西省',
                '620000': '甘肃省',
                '630000': '青海省',
                '640000': '宁夏回族自治区',
                '650000': '新疆维吾尔自治区',
                '710000': '台湾省',
                '810000': '香港特别行政区',
                '820000': '澳门特别行政区'
            },

            // 导入弹框数据
            importDialogVisible: false,
            importCardInfo: '',

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteEidInfo: '',
            
            // 批量修改IMEI弹框数据
            updateImeiDialogVisible: false,
            imeiInfo: ''
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
    this.getList();
  },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listWriteCard(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导出
        exportExcel() {
            exportWriteCardSync(this.form).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 删除单条
        deleteById(row) {
            confirmBox(this, `确定要删除EID为 ${row.eid} 的记录吗？`, '操作提示', () => {
                deleteById({ id: row.id }).then(res => {
                    messageBox(this, '删除成功')
                    this.getList()
                })
            })
        },

        // 写卡操作
        handleWrite(row) {
            this.writeForm = {
                eid: row.eid,
                newIccid: '',
                newMsisdn: ''
            }
            this.writeDialogVisible = true
        },

        // 提交写卡
        submitWrite() {
            if (!this.writeForm.newIccid || !this.writeForm.newMsisdn) {
                this.$message.warning('请填写完整信息')
                return
            }

            writeCard(this.writeForm).then(res => {
                this.$message.success('写卡成功')
                this.writeDialogVisible = false
                this.getList()
            })
        },

        // 编辑操作
        handleEdit(row) {
            this.editForm = {
                id: row.id,
                eid: row.eid,
                imei: row.imei,
                iccid: row.iccid,
                phone: row.phone,
                province: row.province
            }
            this.editDialogVisible = true
        },

        // 提交编辑
        submitEdit() {
            if (!this.editForm.imei || !this.editForm.iccid || !this.editForm.phone) {
                this.$message.warning('请填写必要信息')
                return
            }
            
            // 确保province字段是代码格式而不是省份名称
            // if (this.editForm.province && typeof this.editForm.province === 'string') {
            //     if (Object.values(this.provinceMap).includes(this.editForm.province)) {
            //         // 如果是省份名称，找到对应的代码
            //         for (const [code, name] of Object.entries(this.provinceMap)) {
            //             if (name === this.editForm.province) {
            //                 this.editForm.province = code;
            //                 break;
            //             }
            //         }
            //     }
            // }

            editCard(this.editForm).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || '编辑成功')
                    this.editDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.system_result_message_key || '编辑失败')
                }
            }).catch(err => {
                this.$message.error('编辑失败，请稍后重试')
                console.error(err)
            })
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            let formData = new FormData();
            
            // 处理卡信息
            if (!file && !this.importCardInfo.trim()) {
                messageBox(this, '请选择文件或输入设备卡信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('cardInfos', this.importCardInfo);
            
            importExcel(formData).then(res => {
                console.log(res)
                if (res.system_result_key == '0') {
                    if (file) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['importFile'].value = '';
                            this.importCardInfo = '';
                            this.importDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.importCardInfo = '';
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({name: 'importCardInfos.xls'}).then(res => {
                const filename = 'importCardInfos.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs['deleteFile'].files[0];
            let formData = new FormData();
            
            // 处理EID信息
            if (!file && !this.deleteEidInfo.trim()) {
                messageBox(this, '请选择文件或输入EID信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加EID信息到表单
            formData.append('eids', this.deleteEidInfo);
            
            batchDelete(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert(res.system_result_message_key || '删除成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        if (file) this.$refs['deleteFile'].value = '';
                        this.deleteEidInfo = '';
                        this.deleteDialogVisible = false;
                        this.getList();
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出删除模板   模板开发待提供
        exportDeleteTemplate() {
            exportTemplate({name: 'importEid.xls'}).then(res => {
                const filename = 'importEid.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 格式化省份
        formatProvince(provinceCode) {
            return this.provinceMap[provinceCode] || '未知省份'
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 格式化写号状态
        formatWriteStatus(status) {
            const statusMap = {
                '0': '待写卡',
                '1': '充值成功待写号',
                '2': '写号中',
                '3': '写号完成'
            };
            return statusMap[status] || '-';
        },

        // 打开批量修改IMEI弹窗
        batchUpdateImeiDialog() {
            this.updateImeiDialogVisible = true
        },
        
        // 提交批量修改IMEI
        submitUpdateImei() {
            let file = this.$refs['updateImeiFile'].files[0];
            let formData = new FormData();
            
            // 处理IMEI信息
            if (!file && !this.imeiInfo.trim()) {
                messageBox(this, '请选择文件或输入IMEI信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 无论是否有文件，都添加IMEI信息到表单
            formData.append('imeiInfos', this.imeiInfo);
            
            batchUpdateImei(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert(res.system_result_message_key || '修改成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        if (file) this.$refs['updateImeiFile'].value = '';
                        this.imeiInfo = '';
                        this.updateImeiDialogVisible = false;
                        this.getList();
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },
        
        // 导出IMEI修改模板
        exportImeiTemplate() {
            exportTemplate({name: 'importWriteCardImeis.xls'}).then(res => {
                const filename = 'importWriteCardImeis.xls'
                Utils.createDownload(res, filename)
            })
        },
    }
}
</script>

<style scoped>
.writeCardList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.info-box {
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style>
